export * from './serviceOwner.service';
import { ServiceOwnerService } from './serviceOwner.service';
export * from './serviceOwnerMapping.service';
import { ServiceOwnerMappingService } from './serviceOwnerMapping.service';
export const APIS = [ServiceOwnerService, ServiceOwnerMappingService];
